import { Typography } from '@arionbanki/arionui';
import { Links } from 'components';
import mazeImg from 'img/maze.svg';
import screenImg from 'img/screen.svg';
import type { FinishPageProps } from './useFinish';

export function FinishPrimary({ keys, links, t }: FinishPageProps) {
	return keys.isPrimary ? (
		<>
			<div className="col-12 col-lg-2">
				<img alt="" className="mb-5" src={screenImg} />
			</div>
			<div className="col-12 col-lg-4 mb-5">
				<Typography TagName="h4">{t(keys.leftTitle, 'finish')}</Typography>
				<Typography TagName="p">{t(keys.leftText, 'finish')}</Typography>
				<Links links={links[0]} />
			</div>
			<div className="col-12 col-lg-2">
				<img alt="" className="mb-5" src={mazeImg} />
			</div>
			<div className="col-12 col-lg-4">
				<Typography TagName="h4">{t(keys.rightTitle, 'finish')}</Typography>
				<Typography TagName="p">{t(keys.rightText, 'finish')}</Typography>
				<Links links={links[1]} />
			</div>
		</>
	) : null;
}
